import getLookerUrl, { Metric } from '../repository/getLookerUrl'
import getPartner from '../../Account/repository/getPartner'

const useEarnings = () => {
  const fetchLookerUrl = async (metric: Metric) => getLookerUrl(metric)
  const fetchDeductionsUrl = async () => fetchLookerUrl('deductions')
  const fetchLedgerUrl = async () => fetchLookerUrl('ledger')

  const fetchPaymentsUrl = async (): Promise<string> => {
    const result = await getPartner()

    return 'error' in result ? '' : result.tipalti_payments_url
  }

  return {
    fetchDeductionsUrl,
    fetchLedgerUrl,
    fetchPaymentsUrl
  }
}

export default useEarnings
